import {decorate, observable, action} from "mobx"

export class AuthDataStore {
  availableApps = []
  setAvailableApps(availableApps) {
    this.availableApps = availableApps
  }
}

decorate(AuthDataStore, {
  availableApps: observable,
  setAvailableApps: action,
})
